<template>
    <div class="block space-y-[11px] lg:hidden">
        <template v-for="tab in tabs">
            <div :key="tab.name" v-if="!isActivity || (isActivity && tab.name !== 'lesson_plan_preview')">
                <div :class="[selectedTabName === tab.name ? 'rounded-tl-xl rounded-tr-xl bg-primary-500' : 'rounded-xl bg-primary-100', 'cursor-pointer flex justify-between px-[15px] py-[8px] h-[40px] items-center']"
                    @click="selectedTabName === tab.name ? selectedTabName = '' : selectedTabName = tab.name">
                    <span>{{ tab.label }}</span>

                    <span>
                        <svg :class="selectedTabName !== tab.name ? '' : 'rotate-180'"
                            xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                            <path d="M5.99935 6.50033L0.166016 0.666992H11.8327L5.99935 6.50033Z" fill="#2B2B2B" />
                        </svg>
                    </span>
                </div>

                <div v-if="selectedTabName === tab.name" class="p-[16px] bg-[#EEF1F6] rounded-bl-xl rounded-br-xl">
                    <div v-if="selectedTabName === 'teaching_tips'">
                        <div v-html="resource.teaching_tips"></div>
                        <div v-if="resource.scientist_notes" v-html="resource.scientist_notes" class="mt-4"></div>
                    </div>

                    <div v-else-if="selectedTabName === 'lesson_plan_preview'">
                        <div class="w-full h-[350px]">
                            <!-- {{ resource.teachable }} -->
                            <iframe
                                loading="lazy"
                                :src="resource?.teachable?.url || 'https://docs.google.com/presentation/d/e/2PACX-1vQ8Xoe_t38KzRS2hzgKWisChVoCzprTGLKv-7QqOLHI4wtZhLp0k5FSBeKcRbICfESCmUMeMo4BsP35/embed'"
                                frameborder="0" width="100%" height="100%" allowfullscreen="true"
                                mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
                        </div>
                        <div class="text-right px-6">
                                <a :href="resource.teachable?.url"
                                   class="underline inline-flex space-x-[6px]  text-lg items-center" target="_blank">
                                    <svg width="23" height="23" viewBox="0 0 23 23" fill="none"
                                         xmlns="http://www.w3.org/2000/svg"
                                         xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <rect width="23" height="23" fill="url(#pattern0_99_2191)" />
                                        <defs>
                                            <pattern id="pattern0_99_2191" patternContentUnits="objectBoundingBox"
                                                     width="1" height="1">
                                                <use xlink:href="#image0_99_2191" transform="scale(0.01)" />
                                            </pattern>
                                            <image id="image0_99_2191" width="100" height="100"
                                                   xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADf0lEQVR4nO3dT2sTQRzG8elFRPHPG9B4CCbze5bmEFBE8aDg2bN/QJCqFG9KFau0oqgHiydR9E2or8Cqxx4UPelFvIqIRaoe2pWREau22Q26s7+Zfb4wt2Y62c9uMk1CYwxjjDHGGGOMMcYYYw2r0+lsy7LsCICzInIuwDjd7Xa3D7vOdru9EcDR/70eAJMictUdg36/v87UlbV2r4g8A5DXMJYA3Ci7VgAHAHyoel0i8g5AzwRuBMC0Pyh1YOTLDsDJosVaa1sA5gOu623QK8Vj5ErG6xLrvVbDiXIo2MOUhisDv8aSiKwpAHlQw7ouBwGp8TkjX+VM/FhizfdrWNt0kN1U3QD4G+ROCZB9SYK4LaMyjBf9fn9TybXPJAfi99yDDtCCiMwFGI9F5PywOxlr7UH3fDLk7/qsFqTE7uqVSSgAxwEsEiR+DF4hyjAIogyDIMowCPKviciJIV6BcD/3hSA6rgyHMe52lARRguFvRxAtGP62BNGC4W9PEC0Yfg6CaMHw8xBEC4afiyBaMPx8BNGC4eckiBYMPy9Bqn45xP38EHM/L5jvoqm6mN6gkgoxXAAe1v4xoFhApGKMZW8Hrzbn+06ns8FUXQwgIjJWNcbPANxcYc55a+3+/3uvIgWRgBh/fMTonv/wxBX3sVUTKs0gqGg3pTqtIGgihlYQNBVDIwiajKENBE3H0AQCYugBATH0gMjwf2eMmUC1Wq21pkkgohCj1+ttBnAXwCf/e99kWXbKpA4iCjFGR0fXA3i5yhqum1RBRCGGC8CFgnW0kwMRpRguALMF6xlPCkQUY5R5x1BEppIBQQRb28a8hYsIMBoDgkgwGgGCiDCSBxGRY5qfwBsFYq0FgG8xYSQNIiK3YsNIHeRRbBipg9yODSNpEGvtzgG7qyWNGEmDuETkzAooX93uyygtaRCXiOzwD1/uv7/NZFnWNYpLHiS2CKIsgiiLIMoiiLIIoiyCKIsgyiKIsgiiLIIoiyDKUgGi6F+NzykYCwUgE5WD+O+ZKnp3jwM/Ts7DlYP4rw7S9GUuudLhjtEWEyIATxXc4Vz5mDWhEpE9vEowCGMxy7JdwUA8ypSCszBXOiZNDY2IyCVeKfjtyvAYI6auAOwG8ETBWZnX/AQ+G/xhalAistVt89ze2337ZkPGhLvP7r7XffwZY4wxxhhjjDHGGDOB+w5DziUbzN6bkwAAAABJRU5ErkJggg==" />
                                        </defs>
                                    </svg>
                                    <span>View in new tab</span>
                                </a>
                            </div>
                    </div>

                    <div v-else-if="selectedTabName === 'standards'">
                        <div>
                            <h3 class="font-semibold">Primary Standards</h3>
                            <ul class="-mt-6 trix">
                                <li v-for="(performances, standardName) in primaryStandardsNamesTree" :key="standardName"
                                    class="mt-8">
                                    <span class="font-semibold">{{ standardName }}</span>
                                    <ul class="-mt-6">
                                        <li v-for="(codes, performanceName) in performances" :key="performanceName"
                                            class="mt-8">
                                            <span>{{ performanceName }}</span>
                                            <ul class="-mt-2">
                                                <li v-for="code in codes" :key="code" class="mt-4">
                                                    <span>{{ code }}</span>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div class="mt-8">
                            <h3 class="font-semibold">Supporting Standards</h3>
                            <ul class="-mt-6 trix">
                                <li v-for="(performances, standardName) in supportingStandardsNamesTree"
                                    :key="standardName" class="mt-8">
                                    <span class="font-semibold">{{ standardName }}</span>
                                    <ul class="-mt-6">
                                        <li v-for="(codes, performanceName) in performances" :key="performanceName"
                                            class="mt-8">
                                            <span>{{ performanceName }}</span>
                                            <ul class="-mt-2">
                                                <li v-for="code in codes" :key="code" class="mt-4">
                                                    <span>{{ code }}</span>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div v-else-if="selectedTabName === 'accompanying_materials'">
                        <ul class="list-disc space-y-1 pl-[20px]">
                            <li v-for="embedding in embeddings">
                                <a :href="embedding.url" target="_blank" class="underline">
                                    {{ embedding.name }}
                                </a>
                            </li>

                            <li class="!mt-4">
                                <a href="https://www.youtube.com/watch?v=39XuefVSaH0&ab_channel=SubjectToClimate"
                                    target="_blank" class="underline">How to edit materials</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import { usePage } from '@inertiajs/vue3'

const tabs = [
    {
        label: 'Accompanying Materials',
        name: 'accompanying_materials'
    },
    {
        label: 'Lesson Plan Preview',
        name: 'lesson_plan_preview'
    },
    {
        label: 'Teaching Tips',
        name: 'teaching_tips'
    },
    {
        label: 'Standards',
        name: 'standards'
    },
];
export default {
    props: {
        resource: Object,
        isActivity: Boolean,
    },
    components: {

    },
    data() {
        return {
            selectedTabName: 'scientist-notes',
            embeddings: this.resource?.teachable?.embeddings ?? []
        }
    },
    mounted() {
        console.log(this.resource.teachable?.url)
    },
    computed: {
        selectedTab() {
            let tabs = this.tabs.filter(tab => tab.name == this.selectedTabName);
            if (tabs.length)
                return tabs[0]
            return null;
        },
        primaryStandardsNamesTree() {
            return this.resource.standards_names_trees[this.tenantSlug]['primary']
        },
        supportingStandardsNamesTree() {
            return this.resource.standards_names_trees[this.tenantSlug]['supporting']
        },
    },
    setup() {
        const tenantSlug = usePage().props.tenantSlug

        return {
            tabs,
            tenantSlug
        }
    }
}
</script>
